"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDefault = void 0;
var LftLoading_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftLoading"));
var react_1 = __importDefault(require("react"));
var loading_default_styles_1 = require("./loading-default.styles");
var LoadingDefault = function (_a) {
    var width = _a.width, height = _a.height, testId = _a.testId, bgColor = _a.bgColor;
    return (react_1.default.createElement(loading_default_styles_1.LiftLoadingContainerStyled, { width: width, height: height, "data-testid": testId },
        react_1.default.createElement(LftLoading_1.default, { bgColor: bgColor })));
};
exports.LoadingDefault = LoadingDefault;
